<template>
  <div @click="clickHandle" class="container">    
    <a-row class="card" :class="selected?'selected':''" >
      <a-col :span="24">
        <a-row>
          <a-col :span="isPad?8:4" class="center-panel" >
            <a-progress type="circle" :percent="data.progress" :width="70" />
          </a-col>
          <a-col :span="isPad?16:20">
            <a-tooltip>
              <template slot="title">
                {{data.name}}
              </template>              
              <div class="info-row one-row" @click="editPeriodMark(data)"><edit :width="'18px'"></edit>{{data.name}}</div>
            </a-tooltip>
            <div class="info-row">({{data.formCount}})<period-status-tag :status="data.status" style="cursor: pointer;margin-left: 5px"></period-status-tag></div>
          </a-col>          
        </a-row>
      </a-col>
      <a-col :span="24">
        <div class="info-row">{{data.startDate}}~{{data.endDate}}</div>
      </a-col>
    </a-row> 
    <ul id="dropdown-menu">
      <template v-if="data.groupStatus != '2'" >
        <li v-if="(data.commonFlag & 1)===1" @click="editPeriodVisitDate" title="修改访视日期">修改访视日期</li>
        <li v-if="data.isCopy==='1'" v-has="'patient:period:copy'" @click="copyPeriod" title="复制周期">复制周期</li>
        <li v-if="data.isCopy==='1'" v-has="'patient:period:copy'" @click="delPeriod" title="删除周期">删除周期</li>
        <li v-if="data.isCopy==='1'" v-has="'patient:period:copy'" @click="editPeriod" title="编辑名称">编辑名称</li>
      </template>
      <!-- <li @click="editPeriod" title="备注">备注</li> -->
    </ul>
    <a-modal
        :title="`复制访视周期`"
        :confirmLoading='confirmLoading'
        :width="600"
        :visible="copyPeriodView"
        @ok="copyPeriodOk"
        @cancel="copyPeriodView = false">
        <a-form-model layout="vertical" :rules="rules">
          <a-form-model-item label="被复制的周期">
            {{data?data.name:''}}
          </a-form-model-item>          
          <a-form-model-item label="新周期的名称">            
            <a-input v-model="copyPeriodName" style="width:15rem" placeholder="可以不填,系统默认自动生成"></a-input>
            <a-tooltip placement="topLeft" style="padding-left:2px">
                <template slot="title">
                  如果填入，系统将按照该名称生成
                </template>
                <a-icon type="info-circle" style="color: #FF4500" />
              </a-tooltip>
          </a-form-model-item>
          <a-form-model-item label="访视日期" prop="periodDate">
            <a-date-picker value-format='YYYY-MM-DD' v-model="followPeriodDate" /> 
          </a-form-model-item>    
        </a-form-model>          
      </a-modal>
      <a-modal
        :title="`编辑周期名称`"
        :confirmLoading='confirmLoading'
        :width="600"
        :visible="editPeriodView"
        @ok="editPeriodOk"
        @cancel="editPeriodView = false">        
        <a-form-model-item label="周期的名称">
          <a-input v-model="editPeriodName" style="width:15rem"></a-input>
        </a-form-model-item>                     
      </a-modal>
      <a-modal
        :title="`修改访视日期`"
        :confirmLoading='confirmLoading'
        :width="400"
        :visible="editPeriodDate"
        @ok="editPeriodDateOk"
        @cancel="editPeriodDate = false">
        <a-form-model layout="vertical" :rules="rules">
          <a-form-model-item label="周期">
            {{data?data.name:''}}
          </a-form-model-item>          
          <a-form-model-item label="访视日期" prop="periodDate">
            <a-date-picker value-format='YYYY-MM-DD' v-model="editNewPeriodDate" /> 
          </a-form-model-item>    
        </a-form-model>          
      </a-modal>
      <a-modal
        :title="`周期备注`"
        :confirmLoading='loading'
        :width="600"
        :visible="markPeriodView"
        @ok="markPeriodOk"
        @cancel="markPeriodView = false">        
        <a-form-model-item label="周期的名称">
          {{markPeriod.name}}          
        </a-form-model-item>
        <a-form-model-item label="备注">          
          <a-textarea :rows="2" placeholder="请输入备注" v-model="markPeriod.remark"  class="textarea"/>
        </a-form-model-item>                     
      </a-modal>
  </div>
</template>

<script>
  import PeriodStatusTag from './PeriodStatusTag'
  import moment from 'moment'
  import {CACHE_IS_PAD} from '@/constants/project'
  import Vue from 'vue'
  import { getAction,postAction } from '@/api/manage'
  import baseRules from '@/constants/baseRules'
  import edit from '@comp/Icon/edit'
  export default {
    name: 'FollowPeriodCard',
    components: { PeriodStatusTag, edit},
    props:{
      data:{
        type:Object,
        default:function(){
          return {}
        }
      },
      selected: {
        type:Boolean,
        default:false
      },
    },
    data(){
      return {
        now: new Date(moment().format('YYYY-MM-DD')),
        isPad: Vue.ls.get(CACHE_IS_PAD),
        copyPeriodView:false,
        editPeriodView:false,
        editPeriodDate:false,
        followPeriodDate:undefined,
        editNewPeriodDate:undefined,
        copyPeriodName:'',
        confirmLoading: false,
        editPeriodName:'',
        markPeriod:{
          id:'',
          remark:'',
          name:'',
        },
        markPeriodView: false,
        rules: {
          periodDate: [baseRules.required],
        },
      }
    },
    computed:{
    },
    methods:{
      clickHandle(){
        this.$emit('click',this.data)
      },
      editPeriodVisitDate(){
        this.editPeriodDate = true
        this.getCurrentDate()
      },
      copyPeriod(){
        console.log("copy periodId:"+ this.data.id)

        this.copyPeriodView = true
      },
      editPeriodMark(data){        
        this.markPeriod = {
          id:data.id,
          remark:data.remark,
          name:data.name,
        },
        this.markPeriodView = true
      },
      markPeriodOk(){        
        this.loading = true
        const that = this;
        getAction("/patient/patientPeriodItem/editPeriodMark",{id:this.markPeriod.id,remark:this.markPeriod.remark}).then((res) => {
              if (res.success) {
                this.$message.success(res.message)                
                that.$emit('unload')
              } else {
                this.$message.warning(res.message);
              }
            }).finally(()=>{
              this.loading= false
              this.markPeriodView = false
            });
      },
      editPeriod(){
        console.log("edit periodId:"+ this.data.id)
        this.editPeriodName = this.data.name
        this.editPeriodView = true
      },

      delPeriod(){
        console.log("del periodId:"+ this.data.id)
        const that = this;
        this.$confirm({
          title: '删除周期',
          content: (<div>
            <p>您确定要删除周期【{this.data.name}】吗？</p>
            <p style="color:red;">注意：删除后将同时删除采集的表单数据，无法恢复，请谨慎操作！</p>
          </div>),
          centered: false,
          onOk: () => {
            getAction("/patient/patientPeriodItem/delPeriod",{id:this.data.id}).then((res) => {
              if (res.success) {
                this.$message.success(res.message)                
                that.$emit('unload');
              } else {
                this.$message.warning(res.message);
              }
            });
          },
        })
      },
      copyPeriodOk(){      
        if(!this.followPeriodDate){
          this.$message.warning("请选择访视日期");
          return
        }
        this.confirmLoading = true
        const that = this;
        getAction("/patient/patientPeriodItem/copyPeriod",{id:this.data.id,visitDate:this.followPeriodDate,copyPeriodName:this.copyPeriodName}).then((res) => {
              if (res.success) {
                this.$message.success(res.message)                
                that.$emit('unload');
              } else {
                this.$message.warning(res.message);
              }
            }).finally(()=>{
              this.confirmLoading= false
              this.copyPeriodView = false
            });
      },
      editPeriodOk(){
        if(!this.editPeriodName){
          this.$message.warning("周期名称不能为空");
          return
        }
        this.confirmLoading = true
        const that = this;
        getAction("/patient/patientPeriodItem/editPeriod",{id:this.data.id,editPeriodName:this.editPeriodName}).then((res) => {
              if (res.success) {
                this.$message.success(res.message)                
                that.$emit('unload');
              } else {
                this.$message.warning(res.message);
              }
            }).finally(()=>{
              this.confirmLoading= false
              this.editPeriodView = false
            });
      },
      editPeriodDateOk(){
        if(!this.editNewPeriodDate){
          this.$message.warning("请选择访视日期");
          return
        }
        
        this.confirmLoading = true
        const that = this;       
        postAction('/patient/patient/updateVisitDate', { periodItemId: this.data.id, periodItemDate: this.editNewPeriodDate }).then(res => {
          if (res.success) {            
            this.$message.success(res.message)
            this.editPeriodDate = false
            that.$emit('unload');
          }else {
            this.$message.warning(res.message);
          }
          }).finally(()=>{
            this.confirmLoading = false            
          });        
      },
      getCurrentDate() {
        const today = new Date();
        // 格式化日期为 YYYY-MM-DD 格式
        this.editNewPeriodDate = today.getFullYear() + '-' +
                          ('0' + (today.getMonth() + 1)).slice(-2) + '-' +
                          ('0' + today.getDate()).slice(-2);
      }
    }
  }
</script>

<style scoped lang="less">
  .card{
    border: 1px solid rgba(0,0,0,0.2);
    border-radius: 10px;
    padding: 10px;
    cursor: pointer;
    .info-row{
      margin-bottom: 10px;
    }
  }
  .selected,.card:hover{
    border: 2px solid #1890ff;
  }
  .container:hover #dropdown-menu {
    display: block;
  }
  #dropdown-menu {
    border: 1px gray;
    border-radius: 5px;
    cursor: pointer;
    list-style-type: none;
    text-align: left;
    margin: 0;
    padding: 0;
    background-color: white;
    box-shadow: 0 0 2px rgba(0, 0, 0, 0.1);
    position: absolute;
    left:80%;
    top:8%;
    z-index: 100;
    width: 100px;
    max-height: calc(100vh - 2rem);
    overflow-y: auto;
    // visibility: hidden;
    display: none;
    transition: visibility 0.3s, opacity 0.3s;
}

#dropdown-menu li {
    padding: 0.2rem 0.3rem;
    transition: all 0.2s ease-in-out;    
}

#dropdown-menu li:hover {
    background-color: lightgray;
}

</style>